(() => {
  const shades = {
    bella:'#cfbaa1',darkcoffee:'#6f4c3c',madeleine:'#b79a78',biscuit:'#d8b985',tone:'#dcc3a8',custard:'#e3c6a2',comma:'#e6d1b8',glaze:'#b58b55',nougat:'#deccb6',loom:'#a9876b',
    dune:'#d4c4b0',brunette:'#a97f64',sand:'#e7d6c5',bambi:'#e7ccaf',coco:'#876a5a',cafe:'#8b6843',mellow:'#c19667',bali:'#a27453',honey:'#edc699',butter:'#e7cda9',cream:'#e8ceb8',tones:'#d0ac81',praline:'#c0a786',pinky:'#e3cbab',desert:'#c6a07c',tuscan:'#704a38',seashell:'#d4c4b0',silk:'#e7d6c5',latte:'#d0ac81',
    toasted:'#9f765d',bronzenight:'#79503f',amber:'#ae7651',milebeach:'#d5ad86',richcaramel:'#a8734f',peach:'#e2b99c',porcelaine:'#eed8c5',velvetespresso:'#563b31',sandstone:'#c39875',warmnude:'#d6af94',maple:'#a86f50',marigold:'#bd8356',spicedhoney:'#c99768',oak:'#8b6048'
  };
  const normalize = value => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  const money = cents => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
      }).format((Number(cents) || 0) / 100);
    } catch {
      return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  };
  const variantImage = variant => {
    const image = variant?.featured_image;
    return typeof image === 'string' ? image : image?.src || variant?.featured_media?.preview_image?.src || '';
  };
  const optionIndexes = product => {
    const options = product?.options || [];
    let concealer = -1;
    let foundation = -1;
    options.forEach((option, index) => {
      const name = normalize(typeof option === 'string' ? option : option?.name);
      if (name.includes('conceal')) concealer = index;
      else foundation = index;
    });
    return { concealer, foundation };
  };
  const findComponentVariant = (product, shade) => (product?.variants || []).find(variant =>
    variant.options?.some(option => String(option) === String(shade)) || String(variant.title) === String(shade)
  );

  function init(root) {
    if (root.dataset.rnComplexionReady === 'true') return;
    root.dataset.rnComplexionReady = 'true';
    let data = {};
    try { data = JSON.parse(root.querySelector('[data-rn-complexion-data]')?.textContent || '{}'); } catch {}

    const coverageButtons = [...root.querySelectorAll('[data-rn-coverage]')];
    const shadeSets = [...root.querySelectorAll('[data-rn-shade-set]')];
    const foundationButtons = [...root.querySelectorAll('[data-rn-foundation-shade]')];
    const concealerButtons = [...root.querySelectorAll('[data-rn-concealer-shade]')];
    const continueButton = root.querySelector('[data-rn-continue]');
    const backButton = root.querySelector('[data-rn-back]');
    const steps = [...root.querySelectorAll('[data-rn-complexion-step]')];
    const addButton = root.querySelector('[data-rn-complexion-add]');
    const form = root.querySelector('[data-rn-complexion-form]');
    const variantInput = root.querySelector('[data-rn-complexion-variant]');
    // Both AJAX FormData and native submission need a successful named control.
    variantInput.name = 'id';
    const quantityInput = form.querySelector('[name="quantity"]');
    if (quantityInput) quantityInput.value = '1';
    const price = root.querySelector('[data-rn-complexion-price]');
    const status = root.querySelector('[data-rn-complexion-status]');
    const stageStatus = root.querySelector('[data-rn-stage-status]');
    const foundationHeading = root.querySelector('[data-rn-foundation-heading]');
    const concealerHeading = root.querySelector('[data-rn-concealer-heading]');
    const summaryFoundation = root.querySelector('[data-rn-summary-foundation]');
    const summaryConcealer = root.querySelector('[data-rn-summary-concealer]');
    const foundationImage = root.querySelector('[data-rn-live-product="foundation"] img');
    const fullImage = root.querySelector('[data-rn-live-product="full"] img');
    const concealerImage = root.querySelector('[data-rn-live-product="concealer"] img');
    const state = { type: '', foundationShade: '', concealerShade: '' };

    [...foundationButtons, ...concealerButtons].forEach(button => {
      const value = button.dataset.rnFoundationShade || button.dataset.rnConcealerShade;
      const key = normalize(value);
      const fallbackHue = (key.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0) * 17) % 360;
      button.style.setProperty('--rn-shade', shades[key] || `hsl(${fallbackHue} 28% 61%)`);
      button.title = value;
    });

    const showStep = name => {
      steps.forEach(step => step.classList.toggle('is-active', step.dataset.rnComplexionStep === name));
      root.querySelector('.rn-complexion__panel')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };
    const updateProductImage = (type, shade, button) => {
      const component = type === 'foundation' ? data.components?.foundation : type === 'full' ? data.components?.full : data.components?.concealer;
      const variant = findComponentVariant(component, shade);
      const source = button?.dataset.image || variantImage(variant);
      const target = type === 'foundation' ? foundationImage : type === 'full' ? fullImage : concealerImage;
      if (!source || !target) return;
      target.style.opacity = '.3';
      target.onload = () => { target.style.opacity = '1'; };
      target.src = source;
      target.removeAttribute('srcset');
    };
    const update = () => {
      const typeName = state.type === 'foundation' ? 'Foundation' : state.type === 'full' ? 'Full Coverage Foundation' : '';
      summaryFoundation.textContent = state.foundationShade ? `${typeName} · ${state.foundationShade}` : (typeName || 'Choose your foundation');
      summaryConcealer.textContent = state.concealerShade || 'Choose your concealer';
      root.querySelector('[data-rn-live-foundation-shade]').textContent = state.type === 'foundation' && state.foundationShade ? state.foundationShade : 'Choose your shade';
      root.querySelector('[data-rn-live-full-shade]').textContent = state.type === 'full' && state.foundationShade ? state.foundationShade : 'Choose your shade';
      root.querySelector('[data-rn-live-concealer-shade]').textContent = state.concealerShade || 'Choose your shade';
      continueButton.disabled = !(state.type && state.foundationShade);

      const product = data[state.type];
      const indexes = optionIndexes(product);
      const match = (product?.variants || []).find(variant =>
        indexes.concealer >= 0 && indexes.foundation >= 0 &&
        String(variant.options?.[indexes.concealer]) === String(state.concealerShade) &&
        String(variant.options?.[indexes.foundation]) === String(state.foundationShade)
      );
      if (!match || !state.concealerShade) {
        variantInput.value = '';
        variantInput.removeAttribute('value');
        form?.removeAttribute('data-variant-id');
        addButton.removeAttribute('name');
        addButton.removeAttribute('value');
        addButton.disabled = true;
        price.textContent = '—';
        status.textContent = state.foundationShade ? 'Choose your Concealing Cream shade to complete the Duo.' : 'Choose one foundation shade and one concealer shade.';
        return;
      }
      variantInput.value = String(match.id);
      variantInput.setAttribute('value', String(match.id));
      form?.setAttribute('data-variant-id', String(match.id));
      addButton.removeAttribute('name');
      addButton.setAttribute('value', String(match.id));
      price.textContent = money(match.price);
      addButton.disabled = !match.available;
      addButton.querySelector('span').textContent = match.available ? 'Complete Your Duo' : 'Sold out';
      status.textContent = match.available ? 'Your Complexion Duo is ready to add to your bag.' : 'This shade combination is currently unavailable.';
    };

    coverageButtons.forEach(button => button.addEventListener('click', () => {
      state.type = button.dataset.rnCoverage;
      state.foundationShade = '';
      coverageButtons.forEach(item => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      root.classList.toggle('is-choice-foundation', state.type === 'foundation');
      root.classList.toggle('is-choice-full', state.type === 'full');
      shadeSets.forEach(set => { set.hidden = set.dataset.rnShadeSet !== state.type; });
      root.querySelector('.rn-complexion__empty')?.setAttribute('hidden', '');
      foundationButtons.forEach(item => { item.classList.remove('is-selected'); item.setAttribute('aria-pressed', 'false'); });
      foundationHeading.textContent = state.type === 'foundation' ? 'Choose your Foundation shade' : 'Choose your Full Coverage shade';
      stageStatus.textContent = `${button.querySelector('strong')?.textContent || 'Foundation'} selected`;
      update();
    }));

    foundationButtons.forEach(button => button.addEventListener('click', () => {
      state.foundationShade = button.dataset.rnFoundationShade;
      foundationButtons.forEach(item => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      foundationHeading.textContent = state.foundationShade;
      stageStatus.textContent = `${state.foundationShade} selected`;
      updateProductImage(state.type, state.foundationShade, button);
      update();
    }));

    concealerButtons.forEach(button => button.addEventListener('click', () => {
      state.concealerShade = button.dataset.rnConcealerShade;
      concealerButtons.forEach(item => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      concealerHeading.textContent = state.concealerShade;
      stageStatus.textContent = `${state.foundationShade} + ${state.concealerShade}`;
      updateProductImage('concealer', state.concealerShade, button);
      update();
    }));

    continueButton.addEventListener('click', () => showStep('concealer'));
    backButton.addEventListener('click', () => showStep('foundation'));
    form?.addEventListener('submit', () => {
      const variantId = form.dataset.variantId;
      if (!variantId) return;
      variantInput.value = variantId;
      variantInput.setAttribute('value', variantId);
      addButton.removeAttribute('name');
      addButton.setAttribute('value', variantId);
    }, true);
    update();
  }

  const initAll = scope => scope.querySelectorAll('[data-rn-complexion]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
